const changeProductQuantity = (state, id, quantityDelta) => {
  const newState = {...state}

  if (id == "UNCATEGORIZED") return newState
  
  let newQuantity = newState[id].quantityInStock + quantityDelta;
  if (newQuantity < 0) newQuantity = 0;
  newState[id] = {...newState[id], quantityInStock: newQuantity};
  return newState
}

const changeProductsSort = (state, {ids, groupId}) => {
  return groupId ? {...state, [groupId]: {...state[groupId], childItemIds: ids}} : state
}

const productEntities = (state = {}, {type, payload}) => {
  switch (type) {
    case "SHOP_CART_ADD_ITEM":
      return changeProductQuantity(state, payload.id, -1)
    case "SHOP_CART_REMOVE_ITEM":
      return changeProductQuantity(state, payload.id, 1)
    case "SHOP_PRODUCTS_SORT":
      return changeProductsSort(state, payload)
    default:
      return state
  }
}

export default productEntities
